import { headerSortElement } from '../common/sorters/headerSortElement';
import { mapVenue } from 'pages/tournament/tabs/venuesTab/mapVenue';
import { TabulatorFull as Tabulator } from 'tabulator-tables';
import { competitionEngine, tournamentEngine, TemporalEngine } from 'tods-competition-factory';
import { destroyTipster } from 'components/popovers/tipster';
import { destroyTable } from 'pages/tournament/destroyTable';
import { findAncestor } from 'services/dom/parentAndChild';
import { venueRowFormatter } from './venueRowFormatter';
import { getVenuesColumns } from './getVenueColumns';
import { displayConfig } from 'config/displayConfig';
import { t } from 'i18n';

// constants
import { TOURNAMENT_VENUES } from 'constants/tmxConstants';

type CreateVenuesTableResult = {
  table: any;
  replaceTableData: () => void;
};

export function createVenuesTable({ table }: { table?: any } = {}): CreateVenuesTableResult {
  const nestedTables = new Map();
  const setNestedTable = (venueId: string, courtsTable: any) => {
    if (nestedTables.has(venueId)) return;
    nestedTables.set(venueId, courtsTable);
  };

  const createSchedulingEngine = () => {
    const tournamentRecord = tournamentEngine.getTournament()?.tournamentRecord;
    if (!tournamentRecord) return undefined;
    const engine = new TemporalEngine();
    engine.init(tournamentRecord);
    return engine;
  };

  const getTableData = () => {
    const { venues } = competitionEngine.getVenuesAndCourts();
    const engine = createSchedulingEngine();
    const rows = venues.map((v: any) => mapVenue(v, engine));
    return { rows };
  };

  const replaceTableData = () => {
    const { rows } = getTableData();
    table?.replaceData(rows);
  };

  const columns = getVenuesColumns(nestedTables);

  if (!table) {
    destroyTable({ anchorId: TOURNAMENT_VENUES });
    const element = document.getElementById(TOURNAMENT_VENUES);
    const headerElement = findAncestor(element, 'section')?.querySelector('.tabHeader') as HTMLElement;
    const { rows: data } = getTableData();

    const getHeader = (rows: any[]) => `${t('pages.venues.title')} (${rows.length})`;
    if (headerElement) headerElement.innerHTML = getHeader(data);

    table = new Tabulator(element, {
      headerSortElement: headerSortElement([
        'scheduledMatchUpsCount',
        'venueAbbreviation',
        'availableTime',
        'courtsCount',
        'venueName',
      ]),
      minHeight: window.innerHeight * (displayConfig.get().tableHeightMultiplier ?? 0.85),
      rowFormatter: venueRowFormatter(setNestedTable),
      placeholder: 'No venues',
      layout: 'fitColumns',
      reactiveData: true,
      index: 'venueId',
      columns,
      data,
    });

    table.on('dataChanged', (rows: any[]) => headerElement && (headerElement.innerHTML = getHeader(rows)));
    table.on('dataFiltered', (_filters: any, rows: any[]) => {
      if (headerElement) headerElement.innerHTML = getHeader(rows);
    });
    table.on('scrollVertical', destroyTipster);
    table.on('cellEdited', (cell: any) => {
      const def = cell.getColumn().getDefinition();
      const row = cell.getRow().getData();
      const value = cell.getValue();
      console.log({ cell, row, value, def });
    });
  } else {
    replaceTableData();
  }

  return { table, replaceTableData };
}
